<span
   kendoButton
   look="flat"
   *ngIf="iconOnly"
   kendoTooltip
   title="{{ actionTitleTranslation | translate }}"
   [disabled]="!(actionId | isMessageActionExecutable$: messageInfo | async)"
   (click)="executeAction(actionId)"
>
   <samweb-icon-with-subicon
      class="sam-center"
      [ngClass]="{ 'main-icon': isMainAction, 'other-icon': isOtherAction, 'delete-icon': isDeleteAction }"
      [primaryIcon]="primaryIcon"
      [secondaryIcon]="secondaryIcon"
   ></samweb-icon-with-subicon>
</span>

<button
   *ngIf="!iconOnly"
   kendoButton
   look="flat"
   fxFill
   (click)="executeAction(actionId)"
   [disabled]="!(actionId | isMessageActionExecutable$: messageInfo | async)"
>
   <samweb-icon-with-subicon
      class="sam-center"
      [ngClass]="{ 'main-icon': isMainAction, 'other-icon': isOtherAction, 'delete-icon': isDeleteAction }"
      [primaryIcon]="primaryIcon"
      [secondaryIcon]="secondaryIcon"
   ></samweb-icon-with-subicon>

   <div style="flex: '1'; text-align: left; padding-left: 1em">
      {{ actionTitleTranslation | translate }}
   </div>
</button>
